// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2AGir","resendInfoText":"OnGoingPaymentBox_resendInfoText__JpJ5z"};